// extracted by mini-css-extract-plugin
export default {"rating":"SpecialistRating_rating__t2avb","number":"SpecialistRating_number__TmDUe","count":"SpecialistRating_count__e6bp9","star":"SpecialistRating_star__ejvu4"};